export const COLORS = {
  black: "#000",
  white: "#fff",
  gold300: "#D0BA92",
  gray50: "#F5F3F3",
  gray100: "#E6E4E4",
  gray150: "#CCCACA",
  gray200: "#B3AFAF",
  gray250: "#807C7C",
  gray300: "#333333",
  gray400: "#1A1717",
  error: "#f73e09",
  gold: "#D0BA92",
  gold200: "#EDD4A6",
  red100: "#FFB5C0",
  purple100: "#D4CAFF",
}

export const BREAK_POINTS = {
  laptop: 1280,
  large_desktop: 1440,
  desktop: 1024,
  tablet: 768,
  xs_mobile: 375,
  small: 640,
  medium: 1007,
  large: 1008,
  laptop_small: 1024,
}

export const VIEWPORTS = {
  laptop: `@media only screen and (min-width: ${
    BREAK_POINTS.laptop
  }px) and (max-width: ${BREAK_POINTS.large_desktop - 1}px)`,
  large_desktop: `@media only screen and (min-width: ${BREAK_POINTS.large_desktop}px)`,
  desktop: `@media only screen and (min-width: ${BREAK_POINTS.laptop}px)`,
  desktop_new: `@media only screen and (min-width: ${BREAK_POINTS.desktop}px)`,
  touch: `@media only screen and (max-width: ${BREAK_POINTS.laptop - 1}px)`,
  tablet: `@media only screen and (min-width: ${
    BREAK_POINTS.tablet
  }px) and (max-width: ${BREAK_POINTS.laptop - 1}px)`,
  mobile: `@media only screen and (max-width: ${BREAK_POINTS.tablet - 1}px)`,
  tablet_small: `@media screen and (max-width: ${BREAK_POINTS.small - 1}px)`,
  laptop_small: `@media only screen and (min-width: ${
    BREAK_POINTS.laptop_small
  }px) and (max-width: ${BREAK_POINTS.laptop - 1}px)`,
  tablet_new: `@media only screen and (min-width: ${
    BREAK_POINTS.tablet
  }px) and (max-width: ${BREAK_POINTS.laptop_small - 1}px)`,
}

export const AUTHOR_CLASS = "rich-author"
export const AUTHOR_IMAGE_CLASS = "rich-author-img"
export const AUTHOR_NAME_CLASS = "rich-author-name"
export const BANNER_CLASS = "editor-banner"
export const BANNER_CONTENT_CLASS = "editor-banner-content"
export const BANNER_IMAGE_CLASS = "editor-banner-img"
export const BANNER_IMAGE_REPLACE_ICON_CLASS = "editor-banner-replace-icon"
export const BANNER_SECONDARY_TEXT_CLASS = "editor-banner-link"
export const BANNER_TEXT_CLASS = "editor-banner-text"
export const BANNER_TITLE_CLASS = "editor-banner-heading"
export const GAP_BANNER_CLASS = "editor-gap-banner"
export const GAP_BANNER_IMAGE_CLASS = "editor-gap-banner-img"
export const GAP_BANNER_CONTENT_CLASS = "editor-gap-banner-content"
export const GAP_BANNER_TITLE_CLASS = "editor-gap-banner-title"
export const GAP_BANNER_BUTTON_CLASS = "editor-gap-banner-button"
export const CAROUSEL_CLASS = "rich-carousel"
export const CAROUSEL_ITEM_CLASS = "rich-carousel-item"
export const GRID_CLASS = "rich-grid"
export const GRID_ITEM_SECOND_CLASS = "rich-grid-item-second"
export const IMAGES_CLASS = "rich-images"
export const IMAGES_ITEM_CLASS = "rich-images-item"
export const VIDEO_CLASS = "rich-video"
export const VIDEO_ELEMENT_CLASS = "rich-video-element"
